import SectionPage from "./SectionPage";
import ServiceStyles from "./ServiceStyles";
import Process from "./Process";

export const HowWeWorkPage = () => (
  <SectionPage
    eyebrow="Service Styles · How It Works"
    title="How We Cater"
    subtitle="Two sides of the same coin — the service style we tailor to your event, and the simple, professional process we follow to feed the room reliably."
    hero="charcoal"
  >
    <ServiceStyles />
    <Process />
  </SectionPage>
);

export default HowWeWorkPage;
